import axios from "axios";
import { useAuthStore } from "@/stores/authStore";

const instance = axios.create({
  // nu se seteaza baseURL aici ca sa putem chema doua domenii diferite din modulele API
  // fiecare modul setează direct URL complet
});

// Request: set Token
instance.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response: 401 ⇒ logout with exceptions
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url as string | undefined;
    const status = error.response?.status;
    const isOrchestrator = url?.includes("/orchestrator/");
    const { isDeleting } = useAuthStore.getState();

    if (status === 401 && !isOrchestrator && !isDeleting) {
      console.warn("[Axios] 401 → auto logout");
      useAuthStore.getState().logout();
    }

    return Promise.reject(error);
  }
);

export default instance;